const mutations = {
  SET_SELECTED_TAB(state, payload) {
    state.selectedTab = payload;
  },
  SET_PATIENT_REF(state, payload) {
    state.patientRef = payload;
  },
  RECONSTRUCT_TAB(state) {
    state.nav = state.nav.filter((el) => el.status !== "hidden");
  },
  SET_NAVS(state, payload) {
    state.nav = [...payload];
  },
  SET_CAN_MANAGE_PATIENT(state, payload) {
    state.canManagePatient = payload;
  },
};

export default mutations;
